import { createVNode } from "vue";
import PropTypes from '../_util/vue-types';
import LazyRenderBox from './LazyRenderBox';
export default {
  props: {
    hiddenClassName: PropTypes.string.def(''),
    prefixCls: PropTypes.string,
    visible: PropTypes.bool
  },
  render: function render() {
    var _this = this;

    var _this$$props = this.$props,
        prefixCls = _this$$props.prefixCls,
        visible = _this$$props.visible,
        hiddenClassName = _this$$props.hiddenClassName;
    return createVNode("div", {
      "class": !visible ? hiddenClassName : ''
    }, [createVNode(LazyRenderBox, {
      "class": "".concat(prefixCls, "-content"),
      "visible": visible
    }, {
      default: function _default() {
        return [_this.$slots.default && _this.$slots.default()];
      }
    })]);
  }
};